import { useTranslation } from 'react-i18next';
import { emailRegExp } from '@/util/utils';
export const useFieldRules = () => {
    const { t } = useTranslation();
    const errorMessage = () => {
        return t('fields.invalid');
    };
    const fieldRules = (field, required = false) => {
        const validator = {
            phone: {
                required,
                pattern: /^\+?[0-9]{7,12}$/,
                maxLength: 32,
            },
            display_name: {
                required,
                minLength: 1,
                maxLength: 32,
            },
            address: {
                required,
                minLength: 5,
                maxLength: 128,
            },
            email: {
                pattern: emailRegExp,
                required,
                maxLength: 64,
            },
            language: {
                required,
            },
        };
        if (validator[field]) {
            return validator[field];
        }
        return {
            required,
            minLength: 1,
            maxLength: 32,
        };
    };
    return {
        errorMessage,
        fieldRules,
    };
};
